import { api } from "@/lib/api";

import type {
  CreateRiderSaleReq,
  RiderPendingPaymentSummary,
  RiderSale,
  RiderSaleList,
  RiderSaleStatus,
  UpdateRiderSaleReq,
} from "@artisancode/api-types";

export interface RiderSaleListParams {
  page?: number;
  per_page?: number;
  q?: string;
  rider_id?: string;
  status?: RiderSaleStatus;
  payroll_id?: string;
  date_from?: string;
  date_to?: string;
  workspace_id?: string;
}

export const riderSaleService = {
  list: (params?: RiderSaleListParams) =>
    api.get<RiderSaleList>(
      "/rider-sales",
      params as Record<string, string | number | boolean | undefined>,
    ),

  listAll: async (
    params?: Omit<RiderSaleListParams, "page" | "per_page">,
  ): Promise<RiderSale[]> => {
    const allItems: RiderSale[] = [];
    let page = 1;
    let lastPage = 1;

    do {
      const res = await riderSaleService.list({
        ...params,
        page,
        per_page: 100,
      });
      allItems.push(...res.items);
      lastPage = res.pagination.lastPage || 1;
      page += 1;
    } while (page <= lastPage);

    return allItems;
  },

  create: (body: CreateRiderSaleReq, idempotencyKey?: string) =>
    api.post<RiderSale>(
      "/rider-sales",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  update: (id: string, body: UpdateRiderSaleReq) =>
    api.put<RiderSale>(`/rider-sales/${id}`, body),

  delete: (id: string, reason: string) =>
    api.del(`/rider-sales/${id}`, { reason }),

  void: (id: string, reason: string) =>
    api.post<RiderSale>(`/rider-sales/${id}/void`, { reason }),

  pendingPaymentSummary: (workspaceId?: string) =>
    api.get<RiderPendingPaymentSummary[]>(
      "/rider-sales/pending-payment-summary",
      workspaceId ? { workspace_id: workspaceId } : undefined,
    ),
};
